import React from "react";

import { SharedAppShell } from "~/components/layouts";
import { Pharmacy } from "~/components/pages/Pharmacy";

const PharmacyPage = () => {
  return (
    <SharedAppShell>
      <Pharmacy />
    </SharedAppShell>
  );
};

export default PharmacyPage;
